import { ChangeDetectionStrategy, Component } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';

import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { RouterLinkCreatorService } from '../../../../services/router-link-creator.service';
import { MainNavItemsService } from '../../services/main-nav-items.service';

@Component({
  selector: 'sh-main-nav-about-us',
  templateUrl: './main-nav-about-us.component.html',
  styleUrl: './main-nav-about-us.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class MainNavAboutUsComponent {
  isRouteActive$: Observable<boolean>;

  childRouteList = [
    'our-purpose',
    'about-us',
    'advisory-board',
    'contact'
  ];

  constructor(
    private routerLinkCreatorService: RouterLinkCreatorService,
    private router: Router,
    public items: MainNavItemsService
  ) {
    this.isRouteActive$ = this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      map(() => this.getSegmentsFromUrl(this.router.url)),
      map(segments => (segments?.[1] ? this.childRouteList.includes(segments[1]) : false))
    );
  }

  getSegmentsFromUrl(url: string) {
    // remove initial slash if exist
    if (url?.startsWith('/')) {
      url = url.substring(1) ?? '';
    }

    return url?.split('/');
  }
}
